<!--
* @description  Cascader 级联选择器
* @fileName  Cascader
* @author zlj
* @date 2022-05-31 12:13:51
!-->
<template>
  <div
    class="Cascader"
    ref="cascaderInput"
    :class="{ cascader_right: isRight }"
    :style="{ height: height + 'px' }"
    @mouseenter="inputHover = true"
    @mouseleave="inputHover = false"
  >
    <div
      :style="{ height: height + 'px', border: borSolid, 'border-radius': borRadius }"
      class="input-container flex"
      :class="{
        active_br: (isBorBlue && isClickInput) || isClickInput,
        is_readonly: readonly && !disabled,
        is_disabled: disabled,
        readonly_input: readonly,
        is_error: isRed,
      }"
      @click.stop="selectInput"
    >
      <div
        class="w_p100"
        :style="{
          padding: padding + 'px',
          'box-sizing': 'border-box;',
          'z-index': '1 !important',
        }"
      >
        <el-input
          v-if="inputType === 'selector' || inputType === 'timerSeach'"
          :maxlength="maxlength"
          class=" "
          ref="input"
          v-model="valueType"
          :size="realSize"
          :placeholder="placeholder"
          :readonly="readonly"
          :disabled="disabled"
          :validate-event="false"
          @focus="handleFocus"
          @blur="handleBlur"
          @input="handleInput"
          @change="handleChange"
          :clearable="clearable"
        >
        </el-input>

        <el-input
          v-if="inputType === 'default'"
          class=" "
          :maxlength="maxlength"
          ref="input"
          v-model="value"
          :size="realSize"
          :placeholder="placeholder"
          :readonly="readonly"
          :disabled="disabled"
          :validate-event="false"
          @focus="handleFocus"
          @blur="handleBlur"
          @input="handleInput"
          @change="handleChange"
          :clearable="clearable"
        >
        </el-input>

        <el-input
          v-if="inputType === 'textarea'"
          type="textarea"
          :maxlength="maxlength"
          :show-word-limit="false"
          :resize="'none'"
          :autosize="{ minRows: 2, maxRows: 2 }"
          :placeholder="placeholder"
          v-model="value"
          @focus="handleFocus"
          @blur="handleBlur"
          @input="handleInput(value, $event)"
          @change="handleChange"
          :clearable="clearable"
        >
        </el-input>
      </div>

      <!-- 自定义后置 -->
      <div
        class="input__custom__suffix"
        :class="{
          append_def: isCustomRear,
          append_blue:
            (isBorBlue && isClickInput && isCustomRear) || (isClickInput && isCustomRear),
          append_error: isRed && isCustomRear,
        }"
        :style="{ height: height + 'px', 'line-height': height + 'px', color: '#777' }"
        v-if="isShowRear"
      >
        <div v-if="$slots.custom_suffix">
          <slot name="custom_suffix"></slot>
        </div>
        <div v-else>
          <i
            class="fa"
            :class="{ tf_arrow_on: isClickInput, tf_arrow_down: !isClickInput }"
            @click.stop="
              () => {
                if (!disabled) {
                  isClickInput = !isClickInput;
                }
              }
            "
          >
            <iconComm
              :iconNameCard="
                (isBorBlue && isClickInput) || isClickInput
                  ? 'icon-xiala font_c777'
                  : isRed
                  ? 'icon-xiala is_error_font'
                  : 'icon-xiala font_c777'
              "
              size="16"
            ></iconComm>
          </i>
        </div>
      </div>
    </div>
    <section
      ref="adaptive"
      :class="['adaptive', { w_p100: inputType == 'timerSeach' }]"
      :style="{
        position: inputType == 'selector' ? 'absolute' : '',
        'z-index': '9999 !important',
        right: isRight ? 0 : '',
      }"
    >
      <!--   right: isRight ? 0 : '', -->
      <el-collapse-transition>
        <template v-if="isClickInput">
          <slot></slot>
        </template>
      </el-collapse-transition>
    </section>

    <!-- <transition name="el-zoom-in-top">
      <section
        v-if="isClickInput"
        :class="[{ adaptive: isRight, w_p100: inputType == 'timerSeach' }]"
        :style="{
          position: inputType == 'selector' ? 'absolute' : '',
          'z-index': '999 !important',
        }"
      >
        <template>
          <slot></slot>
        </template>
      </section>
    </transition> -->
    <!--提示弹框（通用）--->
    <Dialog :titleName='"提示"' :TipContent='"单号单次最多可以输入50个"' :iSPublicDialog='true' v-model="publicDialog" v-if="publicDialog">
    </Dialog>
  </div>
</template>

<script>
import bus from "../../../ask/eventBus";
import Dialog from "../../dialog/Dialog.vue"
import iconComm from "../../public/fontIconComm/fontIconComm.vue"
// import { addResizeListener, removeResizeListener } from "@/src/util/resize-event.js";
// import debounce from "throttle-debounce/debounce";
export default {
  props: {
    // 父辈向子辈传参
    // 占位符
    placeholder: {
      type: [String],
      default: "",
    },
    // 尺寸大小
    size: {
      type: [String],
      default: "",
    },
    // 是否 可读
    readonly: {
      type: [Boolean],
      default: true,
    },
    // 是否 禁止操作输入
    disabled: {
      type: [Boolean],
      default: false,
    },
    // 输入框外部间距
    padding: {
      type: [String, Number],
      default: 14,
    },
    // 输入框边框高度
    height: {
      type: [String, Number],
      default: "",
    },
    // 是否需要描边
    borSolid: {
      type: [String, Number],
      default: "",
    },
    // 是否 调整弧度
    borRadius: {
      type: [String, Number],
      default: "",
    },
    // 是否 清空
    clearable: {
      type: [Boolean],
      default: false,
    },
    // 判断输入还是选择器类型
    inputType: {
      type: [String],
      default: "default",
    },

    // // 输入内容
    // valueInput: {
    //   type: [String, Number],
    //   default: '',
    // },
    // 是否 校验输入
    isCheck: {
      type: [Boolean],
      default: false,
    },
    // 是否 显示自定义后置
    isShowRear: {
      type: [Boolean],
      default: true,
    },
    // 是否 开启自定义后置边框样式
    isCustomRear: {
      type: [Boolean],
      default: false,
    },
    // 最大货物尺寸--CM
    maxGoodsSize: {
      type: [Array],
      default: () => [
        {
          maxGoods: "",
          placeholder: "长",
        },
        {
          maxGoods: "",
          placeholder: "宽",
        },
        {
          maxGoods: "",
          placeholder: "高",
        },
      ],
    },
    // 可输入最大长度
    maxlength: {
      type: [String, Number],
      default: "",
    },
    // 是否开启 文本 中英文校验
    isCheckChAndEng: {
      type: [Boolean],
      default: false,
    },
    // 是否开启 文本 纯数字校验
    isCheckNumber: {
      type: [Boolean],
      default: false,
    },
    // 是否开启 文本 手机号
    isCheckPhone: {
      type: [Boolean],
      default: false,
    },
    // 是否开启 文本 中文、英文，数字、常规符号
    isCheckRoutine: {
      type: [Boolean],
      default: false,
    },
    // 是否开启 文本 中文
    isCheckCh: {
      type: [Boolean],
      default: false,
    },
    // 去除前后空格
    isCheckBeforeAfter: {
      type: [Boolean],
      default: false,
    },
    // 联级是否右对齐
    isRight: {
      type: [Boolean],
      default: false,
    },
    // 是否 占位文字
    isPlaceholder: {
      type: [Boolean],
      default: false,
    },
    //是否是富文本，订单单次不超过50个限制
    isTextareaNum:{
      type: [Boolean],
      default: false,
    }
  },
  name: "Cascader",
  data() {
    return {
      isClickInput: false, //是否 点击输入框
      isAnyClick: false, // 是否 除输入框外点击
      isBorBlue: false, //是否 显示边框为蓝色
      docWidth: "",

      // dropDownVisible: false,
      // checkedValue: this.value,
      // inputHover: false,
      // inputValue: null,
      // presentText: null,
      // presentTags: [],
      // checkedNodes: [],
      // filtering: false,
      // suggestions: [],
      // inputInitialHeight: 0,
      // pressDeleteCount: 0,
      // multiple: '',

      value: "", // v-model
      valueType: "",
      // placeholdertext: '此项必填',
      isRed: false,
      expandIsWidth: "",
      isShowTxtPlaceholder: false,
      publicDialog:false,//公共弹框
    };
  },
  created() {
    // 实例被创建之后执行代码
    if (process.client) {
      // this.changeMargin();
    }
  },
  computed: {
    // 计算属性
    // valueType: {
    //   get() {
    //     return this.valueType
    //   },
    //   set(val) {
    //     this.$emit('input', val)
    //   }
    // },
    realSize() {
      return this.size || {}.size;
    },
  },
  components: {
    // 组件的引用
    iconComm,Dialog
  },
  methods: {
    // 方法

    // 获取聚焦
    handleFocus(ev) {
      this.isBorBlue = true;
      this.isRed = false;
      console.log(ev, "ev");
      this.$emit("focus", ev);
      if (!this.readonly) {
        ev.target.select();
        this.isShowTxtPlaceholder = this.isPlaceholder;
        if (this.isShowTxtPlaceholder && this.valueType.length > 0) {
          ev.target.attributes.placeholder.value = this.valueType;
          this.valueType = "";
        }
      }

      // bus.$emit('closeClickInput', this.isBorBlue)
    },
    // 失去焦点
    handleBlur(e) {
      this.isBorBlue = false;
      this.$emit("blur", e);
      this.isShowTxtPlaceholder = this.isPlaceholder;
      if (!this.readonly && this.isShowTxtPlaceholder) {
        e.target.attributes.placeholder.value == this.placeholder &&
        this.valueType.length == 0
          ? ""
          : (this.valueType = e.target.attributes.placeholder.value);
      }
      this.$forceUpdate();
    },
    // 输入框
    handleInput(val = "", event) {
      //console.log("======val",val);
      if (this.isCheckChAndEng) {
        this.checkChAndEng(val);
      }
      if (this.isCheckNumber) {
        this.checkNumber(val);
      }
      if (this.isCheckPhone) {
        this.checkPhone(val);
      }
      if (this.isCheckRoutine) {
        this.checkRoutine(val);
      }
      if (this.isCheckCh) {
        this.checkCh(val);
      }
    

      if (this.isCheckBeforeAfter) {
        this.checkBeforeAfter(val);
        this.clearBlank(val);//去除所有空格
      }
      


      this.$emit("input", val, this.value || "");

      if(this.isTextareaNum){
        console.log("====文本域长度====",val);
        if(val){
          let orderId  = val.split("\n");
          if(orderId.length>50){
            this.publicDialog = true;
            return false;
          }
        }
      }
      // console.log(val, event, "输入框级联选择器")
    },
    //
    handleChange() {
      this.$emit("change");
    },
    // 折叠
    selectInput() {
      if (!this.disabled) {
        this.isClickInput = true;
        if (this.isClickInput == true) {
          this.isBorBlue = true;
          this.isRed = false;

          bus.$emit("closeClickInput");
        }
      }
    },
    //如果为空  提示
    showTips() {
      // if (!this.disabled) {
      //是否显示红色的线提示为空
      this.isRed = this.isCheck;
      // }
    },

    /**
     * 文本校验
     * **/
    // 中英文
    checkChAndEng(ctrValue) {
      let pattern = ctrValue.replace(/[^\a-\z\A-\Z\u4E00-\u9FA5]/g, "");
      return (this.value = this.valueType = pattern);
    },
    // 数字、特殊符号
    checkNumber(ctrValue) {
      let pattern = ctrValue.replace(/[^\0-9]/g, "");
      return (this.value = this.valueType = pattern.trim());
    },
    // 匹配手机号
    checkPhone(ctrValue) {
      let pattern = ctrValue
        .replace(/[^\0-9]/g, "")
        .replace(
          /[\[\]{};',./:"<>?!@#$%^&*()_+【】、；‘，。、{}|：”“《》？！@#￥%……&*（）——+-]*/g,
          ""
        );
      // console.log("手机号", pattern, ctrValue)
      return (this.value = this.valueType = pattern.trim());
    },
    // 中文、英文，数字、常规符号
    checkRoutine(ctrValue) {
      let pattern = ctrValue.replace(
        /[^\a-\z\A-\Z0-9\u4E00-\u9FA5\.\,\?\<\>\。\，\-\——\=\;\@\！\!\+\$]/g,
        ""
      );
      return (this.value = this.valueType = pattern);
    },
    // 中文
    checkCh(ctrValue) {
      let pattern = ctrValue.replace(/[^\u4E00-\u9FA5]/g, "");
      return (this.value = this.valueType = pattern);
    },
    // 去除前后空格
    checkBeforeAfter(ctrValue) {
      let pattern = ctrValue.replace(/(^\s*)|(\s*$)/g, "");
      return (this.value = this.valueType = pattern);
    },
    clearBlank(value){
        if(value){
            value = value.replace(/\s/g,"")
        }
        return value
    },
    changeMargin() {
      //获取网页可见区域宽度
      this.docWidth = `0px`;
      // var docWidth = window.innerWidth;
      // // console.log(docWidth, "获取网页可见区域宽度", document.documentElement.clientWidth);
      // if (docWidth <= 1800 && this.isRight) {
      //   this.docWidth = `0px`;
      // } else {
      //   this.docWidth = "";
      // }
      // this.$forceUpdate();
    },

    updateStyle() {
      const { $el, inputInitialHeight } = this;
      console.log("this.$isServer", $el);
      if (this.$isServer || !$el) return;

      const { suggestionPanel } = this.$refs;
      const inputInner = $el.querySelector(".el-input__inner");
      // console.log(inputInner, "inputInner", this.$refs);

      // if (!inputInner) return;

      // const tags = $el.querySelector('.el-cascader__tags');
      // let suggestionPanelEl = null;

      // if (suggestionPanel && (suggestionPanelEl = suggestionPanel.$el)) {
      //   const suggestionList = suggestionPanelEl.querySelector('.el-cascader__suggestion-list');
      //   suggestionList.style.minWidth = inputInner.offsetWidth + 'px';
      // }

      // if (tags) {
      //   const offsetHeight = Math.round(tags.getBoundingClientRect().height);
      //   const height = Math.max(offsetHeight + 6, inputInitialHeight) + 'px';
      //   inputInner.style.height = height;
      //   if (this.dropDownVisible) {
      //     this.updatePopper();
      //   }
      // }
    },
  },
  mounted() {
    // 页面进入时加载内容
    this.$nextTick(() => {
      //区域关闭
      document.addEventListener(
        "click",
        (e) => {
          if (this.isClickInput == true) {
            var anyClick = this.$refs.cascaderInput;
            if (anyClick && !anyClick.contains(e.target)) {
              this.isClickInput = false;
              // this.isShowTxtPlaceholder = false;
              // bus.$emit('closeClickInput', this.isClickInput)
            }
          } else {
            if (this.isCheck) return;

            if (!this.disabled) {
              this.isBorBlue = true;
              this.isRed = false;
              // this.isShowTxtPlaceholder = true;
            }
          }
        },
        true
      );
    });

    // addResizeListener(this.$el, this.updateStyle);
    // window.addEventListener("resize", this.changeMargin);
  },
  watch: {
    // 监测变化
  },
  // 销毁监听事件
  beforeDestroy() {
    this.$nextTick(() => {
      document.addEventListener(
        "click",
        (e) => {
          if (this.isClickInput == true) {
            var anyClick = this.$refs.cascaderInput;
            if (anyClick && !anyClick.contains(e.target)) {
              this.isClickInput = false;
            }
          } else {
            if (this.isCheck) return;
            if (!this.disabled) {
              this.isBorBlue = true;
              this.isRed = false;
            }
          }
        },
        true
      );
    });
  },
};
</script>
<style scoped lang="scss">
[v-cloak] {
  display: none !important;
}

::v-deep{
  .el-input__inner {
    font-size: 13px !important;
    border: none !important;
    padding: 0 !important;
    color: #333333;
    z-index: 0 !important;
    height: 28px !important;
    border-radius: 0 !important;
  }
} 
::v-deep .readonly_input .el-input__inner {
  max-width: 140px !important;
}
::v-deep .is_readonly .el-input__inner {
  cursor: pointer;
}

::v-deep.el-input__suffix {
  .el-input__suffix-inner {
    .el-icon-circle-close.el-input__clear {
      font-size: 13px;
      line-height: 13px;
      box-sizing: border-box;
      text-align: right;
    }
  }
}

::v-deep.el-textarea textarea {
  // resize: none;
  box-sizing: border-box;
  font-size: 13px !important;
  color: #333;
  height: 56px;
  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-thumb {
    cursor: pointer;
    // -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.6);
    background: #dddddd;
    border-radius: 2px;
  }
  &::-webkit-scrollbar-track {
    // -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: none;
  }

  &::-webkit-input-placeholder {
    font-size: 13px !important;
    color: #aaaaaa !important;
  }
  &::-moz-placeholder {
    font-size: 13px !important;
    color: #aaaaaa !important;
  }
  &:-moz-placeholder {
    font-size: 13px !important;
    color: #aaaaaa !important;
  }
  &::-ms-input-placeholder {
    font-size: 13px !important;
    color: #aaaaaa !important;
  }
}
::v-deep .el-textarea__inner {
  border: none;
  padding: 6px 0 !important;
}

.w_p100 {
  width: 100%;
}
.active_br {
  border: 1px solid #0046b9 !important;
  background: rgba(247, 248, 250, 0.8);
  // box-shadow: 0 0 0 2px rgba(0, 70, 185, 0.16);
  // transition: box-shadow 0.7s;
}
.is_disabled {
  background-color: rgba(221, 221, 221, 0.4) !important;
  cursor: not-allowed;

  ::v-deep .el-input__inner {
    background-color: rgba(221, 221, 221, 0) !important;
    color: #aaaaaa !important;
  }
}
.Cascader {
  // position: relative;
  .input-container {
    height: 100%;
    border-radius: 8px;
    border: 1px solid #d9d9d9;
    box-sizing: border-box;
    background-color: #ffffff;
    transition: border 0.2s ease-in-out, background 0.2s ease-in-out,
      box-shadow 0.2s ease-in-out;
    &:hover {
      border: 1px solid #aaaaaa;
      .append_def {
        border-left: 1px solid #aaaaaa;
      }
    }
    .input__suffix__text {
      background-color: #0046b9;
      padding: 14px 30px;
      border-radius: 8px;
      color: #fff;
      width: 100px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      cursor: pointer;
      &:hover {
        background-color: #0643a6;
      }
    }
    .input__custom__suffix {
      // padding: 10px;
      padding: 0 8px;
      // line-height: 40px;
      .fa {
        line-height: inherit !important;
      }
    }
  }
  .is_disabled {
    &:hover {
      border: 1px solid #d9d9d9;
    }
  }
}

.is_error {
  border: 1px solid #d83f3f !important;
  background: rgba(216, 63, 63, 0.08) !important;
  ::v-deep .el-textarea__inner{
    background: rgba(216, 63, 63, 0) !important;
  }
}
.Cascader .is_error ::v-deep.el-input__inner {
  background: none !important;
  &::placeholder {
    color: #d83f3f !important;
  }
}
.is_error_font {
  color: #d83f3f !important;
}

.append_def {
  border-left: 1px solid #d9d9d9;
  background: rgba(221, 221, 221, 0.16);
}
.append_blue {
  border-left: 1px solid #0046b9 !important;
}
.append_error {
  border-left: 1px solid #d83f3f !important;
}
.cascader_right {
  position: relative;
  .adaptive {
    transition: translate(-50%, 0);
  }
}

// @media only screen and (max-width: 1366px) {
//   .adaptive {
//     right: 0;
//     transition: translate(50%, 50%);
//   }
//   .public-layout {
//     min-width: 0;
//     overflow-x: hidden;
//   }
// }
</style>
